<template>
  <div class="form-holder">
    <div class="message">
      <p>
        {{
          isSuccesfullAndAccesscode
            ? "Thank you, you're now signed up!"
            : 'Thank you for using the tool.'
        }}
      </p>
      <p>
        {{
          isSuccesfullAndAccesscode
            ? ""
            : "Please enter your email address and details for continued access."
        }}
      </p>
    </div>

    <div class="input-wrapper" v-if="accessCode === null">
      <div class="input-wrapper--name">
        <div class="name-holder input-content">
          <input
            :class="{
              'error-input':
                !$v.userDetails.firstname.required && $v.dirty
            }"
            placeholder="First name"
            v-model="$v.userDetails.firstname.$model"
          />
          <div
            class="error"
            v-if="!$v.userDetails.firstname.required && $v.$dirty"
          >
            First name field is required
          </div>

        </div>
        <div class="name-holder input-content">
          <input
            :class="{
              'error-input':
                !$v.userDetails.lastname.required && $v.dirty
            }"
            placeholder="Last name"
            v-model="$v.userDetails.lastname.$model"
          />
          <div
            class="error"
            v-if="!$v.userDetails.lastname.required && $v.$dirty"
          >
            Last name field is required
          </div>

        </div>
      </div>
      <div class="input-content">
        <input
          :class="{
            'error-input':
              !$v.userDetails.company.required && $v.dirty
          }"
          type="text"
          v-model="$v.userDetails.company.$model"
          placeholder="Company name"
        />
        <div class="error" v-if="!$v.userDetails.company.required && $v.$dirty">
          Company is required
        </div>
      </div>
      <div class="input-content">
        <input
          :class="{
            'error-input':
              !$v.userDetails.email.required && $v.dirty
          }"
          type="text"
          v-model="$v.userDetails.email.$model"
          placeholder="Your email e.g your@email.com"
        />
        <div class="error" v-if="!$v.userDetails.email.required && $v.$dirty">
          Email is required
        </div>
        <div class="error" v-if="!$v.userDetails.email.email && $v.$dirty">
          Please enter a valid email
        </div>
      </div>
      <div class="terms-conditions">
        <input type="checkbox" v-model="userDetails.termsAgreed"/>
        <p @click="$emit('showTerms')">I consent to the <span class="terms-conditions--link"> Terms And Conditions </span></p>
        <div class="error" v-if="showFormTermsError" > Please agree to our T&Cs</div>
      </div>
      <div class="terms-conditions">
        <input type="checkbox" v-model="userDetails.marketingAgreed"/>
        <p> I agree to receiving marketing communications</p>
        <div class="error" v-if="showFormMarketingError" > Please agree this condition</div>
      </div>
      <div class="terms-conditions">
        <input type="checkbox" v-model="userDetails.eeaAgreed"/>
        <p>I consent to my personal data being transferred outside of the EEA</p>
        <div class="error" v-if="showFormEeaError" > Please agree this condition</div>
      </div>
      <div class="area-holder theme-button center-content">
        <button
          @click="submitUserEmail"
          :class="{ 'normal-state': !isSubmitting }"
        >
          <font-awesome-icon
            class="button-icon"
            :class="{ 'button-icon--show': isSubmitting }"
            :icon="[
              isSubmitting ? 'fad' : 'fal',
              isSubmitting ? 'spinner-third' : 'paper-plane',
            ]"
            :spin="isSubmitting"
          ></font-awesome-icon
          >Submit
        </button>
      </div>
    </div>
    <div v-if="isSuccesfullAndAccesscode" class="access-code theme-button">
      <!-- <p>{{ accessCode }}</p> -->
      <button class="button-icon" @click="$emit('closeModalPopUp')">
        Close
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { required, email, minLength } from 'vuelidate/lib/validators';
import axios from 'axios';

@Component
export default class UserDetailsCapture extends Vue {
  public userDetails = {
    firstname: '',
    lastname: '',
    company: '',
    email: '',
    termsAgreed: false,
    marketingAgreed: false,
    eeaAgreed: false,
  };
  public isSubmitting = false;
  public isSuccessful = false;
  public accessCode: any = null;
  public showFormTermsError = false;
  public showFormMarketingError = false;
  public showFormEeaError = false;

  @Validations()
  validations = {
    userDetails: {
      firstname: { required, minLength: minLength(1) },
      lastname: { required, minLength: minLength(1) },
      company:{required},
      email: { required, email },
      termsAgreed: {required},
      marketingAgreed: {required},
      eeaAgreed: {required},
    },
  };

  public async submitUserEmail(): Promise<void> {
    this.$v.$touch();
    if (!this.$v.$invalid && this.areAllConditionsAgreed) {
      try {
        const baseApi = `${process.env.VUE_APP_APIADDRESS}/gbeEmail/postNewContact`;

        this.isSubmitting = true;
       const {status} = await  axios.post(baseApi, {name: `${this.userDetails.firstname} ${this.userDetails.lastname}`, company: this.userDetails.company , emailAddress: this.userDetails.email})

       if(status === 200) {
         this.isSubmitting = false;
          this.isSuccessful = true;
          this.$v.$reset();
          this.accessCode = Math.floor(100000 + Math.random() * 900000).toString();
          localStorage.setItem(
          'e918d0ce-2fe3-47f1-b4cd-0f161624f7c7',
          this.accessCode
        );
       }
      } catch (error) {
        //
      }
    } else {
      this.showFormTermsError = !this.$v.userDetails.termsAgreed?.$model;
      this.showFormMarketingError = !this.$v.userDetails.marketingAgreed?.$model;
      this.showFormEeaError = !this.$v.userDetails.eeaAgreed?.$model;
    }
  }

  get isSuccesfullAndAccesscode() {
    return this.accessCode !== null && this.isSuccessful;
  }

  get areAllConditionsAgreed() {
    return this.$v.userDetails.termsAgreed?.$model && this.$v.userDetails.marketingAgreed?.$model && this.$v.userDetails.eeaAgreed?.$model;
  }
}
</script>

<style lang="scss" scoped>
.form-holder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
  width: 60rem;
  padding: 4rem 8rem;
  @include mix.responsive('xs') {
    width: 100%;
    padding: 2rem 4rem;
  }
  .message {
    text-align: center;
    p {
      line-height: 1.7;
    }
  }
  .input-wrapper {
    margin-top: 2rem;
    width: 100%;
    label {
      display: block;
      margin-bottom: 0.5rem;
    }
    &--name {
      display: flex;
      // margin-bottom: 1.5rem;
      @include mix.responsive('xs') {
        flex-direction: column;
      }
      .name-holder {
        &:first-of-type {
          margin-right: 1rem;
          @include mix.responsive('xs') {
            margin-right: 0;
            margin-bottom: 1rem;
          }
        }
      }
    }
    .input-content {
      width: 100%;
      margin-bottom: 2rem;
      input {
        height: 4rem;
        width: 100%;
        padding-left: 1rem;
      }
    }

    .center-content {
      height: 5rem;
      justify-content: center;
      margin-top: 2rem;
    }

    .terms-conditions {
      position: relative;
      margin-top: 1rem;
      display: flex;
      align-items: center;
      &--link {
        text-decoration: underline;
        cursor: pointer;
      }
      input{
        margin-right: 1rem;
        cursor: pointer;
      }
      p {
        font-size: 1.3rem;
        vertical-align: middle;
      }
      .error {
        margin-top: 0;
        margin-left: 1rem;
      }
    }
    button {
      right: initial;
      font-size: 1.6rem;
      height: 5rem;

        @include mix.responsive("sm") {

            width: 15rem;
        }
    }
  }

  .access-code {
    margin: 1rem 0;
    p {
      margin-bottom: 1rem;
      font-size: 3.5rem;
      font-weight: bold;
      text-align: center;
      word-spacing: 0.5rem;
    }
    button {
      position: initial;
      right: initial;
      height: 4.5rem;

    }
  }
}
.error-input {
  border: 1px solid red;
  &:focus {
    border: 1px solid red;
  }
}
.error {
  color: red;
  font-size: 1.1rem;
  margin-top: 0.46rem;
}
</style>
